import { render, staticRenderFns } from "./index-list-group.vue?vue&type=template&id=c61db460&"
import script from "./index-list-group.vue?vue&type=script&lang=js&"
export * from "./index-list-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports